import http from '../../../libs/http';
import * as types from './follow-official-accounts-types';

/**
 * 获取二维码
 */
export const QRCODE_GET = ({ commit }) => http.post('/peer_account_qrcode_get').then((data) => {
  commit(types.SET_QRCODE, { qrcode: data.qrcode });
});




// WEBPACK FOOTER //
// ./src/store/modules/follow-official-accounts/follow-official-accounts-actions.js